<template>
  <div class="fill-height">
    <v-card  class="fill-height">
      <v-card-text>
        <v-form ref="form" @submit.prevent="save" lazy-validation >
          <v-row>
            <v-chip
                label small
                class="m-2 "
                color="secondary"
            >
              تعریف / ویرایش نقش
              FD-18-1
            </v-chip>
            <v-spacer/>
            <v-btn small style="background-color:#be1e0b" dark icon @click="closed">
              <v-icon>mdi-close</v-icon>
            </v-btn>

          </v-row>

            <v-row>

              <v-col
                  cols="12"
                  sm="4"
              >

                <v-text-field
                    label="نام"
                    outlined
                    dense
                    :error-messages="getError('roleName')"
                    v-model="model.roleName"
                />

              </v-col>
              <v-col
                  cols="12"
                  sm="4"
                  >

                <v-checkbox
                    v-model="selectAll"
                    label="انتخاب همه "
                    @click="select_All()"
                    :error-messages="getError('selected')"
                />
              </v-col>
              <v-col
                  cols="12"
                  sm="4">

                <v-btn
                    small
                    depressed
                    block
                    color="success"
                    class=" p-1 m-1"
                    type="submit"
                    :loading="loading"
                >
                  ذخیره
                </v-btn>
              </v-col>

            </v-row>
            <v-list
                dense
                flat
                class="p-0 m-0"
            >
              <v-row>


                <v-col md="4" v-for="item in model.permissions" :key="item.key">
                  <v-card outlined >


                    <v-chip
                        small
                        label
                        class=" btn-block"
                        color="secondary"
                    >
                      {{item.key}}
                    </v-chip>


                    <v-list-item-group

                        v-for="(element,index) in item.values"
                        :key="index"
                        multiple
                    >
                      <v-list-item dense class="p-0 m-0" >
                        <v-checkbox class="p-1 m-1"
                                    dense
                                    :input-value="element.val"
                                    :label="element.caption"
                                    v-model="selected"
                                    :value="element.name"
                                    color="primary"
                        ></v-checkbox>
                      </v-list-item>
                    </v-list-item-group>
                  </v-card>

                </v-col>
              </v-row>


            </v-list>

          </v-form>
        </v-card-text>
      </v-card>
    </div>

</template>

<script>
import Role_se from "@/views/define/role/Role_se";


export default {
  props: {
    id: String,
  },
  data() {
    return {
      modelId:"",
      model:{},
      selected:[],
      bindingErrors: [],
      selectAll: false,
      loading: false,
      selectitem:[],


    }
  },




  methods: {

    fetch() {
      Role_se.getById(this.modelId).then(response => {
        this.model = response.data.model
        this.convert2Array()
      })
    },
    forEdit: function () {
      this.modelId = this.id;
      this.fetch()
    },

    forNew: function () {
      this.model = {};
      this.modelId = null;
      this.fetch()
    },

    convert2Array() {
      this.selected = [];
      let permissions = this.model.permissions
      for (let item in permissions) {
        let values = permissions[item].values
        for (let i in values) {
          if (values[i].val) {
            this.selected.push(values[i].name);
          }
        }
      }
    },


    select_All(){
      this.selected = [];
      let permissions=this.model.permissions
      if (this.selectAll) {
        for (let item in permissions) {
          let values=permissions[item].values
          for (let i in values)
            this.selected.push(values[i].name);
        }
      }
    },


    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find( ({ fieldName }) => fieldName === key );
        if(error && error.message ) return  error.message[0]
      }
      return ''
    },
    closed() {
      this.bindingErrors=[]
      this.selected=[]
      this.selectAll=false
      this.loading=false
      this.$root.$emit('Role' )
      this.$router.go(-1);

    },


    save() {
      this.loading=true

      this.bindingErrors = []
        Role_se.save(this.model.roleName,this.selected,this.model.id).then(response => {
          if (response && response.status === 200) {
            this.$snack({type: 'success'})
            this.closed()
          }else if (response && response.response.status === 400) {
            this.loading=false
            this.bindingErrors = response.response.data;
          }
        })

    },

  },

  created() {
    if(this.id==='new'){
      this.forNew()
    }else {
      this.forEdit()
    }
  },
  computed: {},
  watch: {
    id: function() { // watch it
      if(this.id==='new'){
        this.forNew()
      }else {
        this.forEdit()
      }


    }
  }

}
</script>


